import React from 'react';
import { Link, useMatch } from 'react-router-dom';
import useProjectPermissions from '../../hooks/useProjectPermissions';

export default function ProjectAccessBoundary({ children }) {
  const match = useMatch('/project/:projectId/*');
  const projectId = match?.params.projectId;
  const { role, loading, error, retry } = useProjectPermissions(projectId);
  if (!projectId) return children;
  if (!loading && role) return children;

  return <main className="min-h-screen flex flex-col items-center justify-center gap-4 p-8 text-center" style={{ backgroundColor: 'var(--color-bg-primary)', color: 'var(--color-text-primary)' }}>
    {loading ? <p role="status">正在确认项目访问权限…</p> : <>
      <div role="alert"><h1 className="text-lg font-semibold">{error ? '暂时无法确认项目权限' : '无权访问此项目'}</h1><p className="mt-2 text-sm" style={{ color: 'var(--color-text-muted)' }}>{error ? '请稍后重试。权限确认前不会加载项目内容。' : '仅项目成员或管理员可以进入制作区。查看已上架作品的数据，请前往短剧排行榜。'}</p></div>
      <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
        {error ? <button type="button" onClick={retry} className="rounded-lg border px-4 py-2" style={{ borderColor: 'var(--color-border-primary)' }}>重试</button> : null}
        <Link to="/" className="underline underline-offset-4">返回我的项目</Link>
        <Link to="/hongguo-rankings" className="underline underline-offset-4">短剧排行榜</Link>
      </div>
    </>}
  </main>;
}
